module.exports = __webpack_public_path__ + "static/media/spinner.c16b62bb.svg";